/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Revertscheduledchangeconfirmtitle4Inputs */

const en_revertscheduledchangeconfirmtitle4 = /** @type {(inputs: Revertscheduledchangeconfirmtitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Undo the scheduled change?`)
};

const de_revertscheduledchangeconfirmtitle4 = /** @type {(inputs: Revertscheduledchangeconfirmtitle4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geplanten Wechsel rückgängig machen?`)
};

/**
* | output |
* | --- |
* | "Undo the scheduled change?" |
*
* @param {Revertscheduledchangeconfirmtitle4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const revertscheduledchangeconfirmtitle4 = /** @type {((inputs?: Revertscheduledchangeconfirmtitle4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Revertscheduledchangeconfirmtitle4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_revertscheduledchangeconfirmtitle4(inputs)
	return de_revertscheduledchangeconfirmtitle4(inputs)
});
export { revertscheduledchangeconfirmtitle4 as "revertScheduledChangeConfirmTitle" }